//@ts-check
import Fuse from 'fuse.js'





/*

	props.options : 
		search : ne pas afficher la recherche 			true
		valide : afficher le boutton valider 			true

		keys : spécifier un k,v spécifique				{k:"k",v:"v"}

		unique : ne pas afficher les items en double par le K false



*/


// composant checkbox
const dropdownFilter = {
	props: {
		param: Object,
		options :Object,
		fuseoptions:Object,
		name : String,
		value : Object,
		list : Array,
	},
	data() {

		//console.log( "composant démarre ", this.param )
		let fuseOptions = { includeScore: false, minMatchCharLength: 2, threshold: 0.2, keys: ['v'] }
		
		if(this.fuseOptions){
			fuseOptions = this.fuseOptions  
		}

 
		let composantOption = {
			search:  true,
			valide: true,
		}

		let opt = (this.options)?this.options:{};
		

		if(opt.search!==undefined ) composantOption.search = opt.search;
		if(opt.valide!==undefined ) composantOption.valide = opt.valide;
		if(opt.keys) 				composantOption.keys = opt.keys;  
		if(opt.unique) 				composantOption.unique = opt.unique;  
		//
		return {
			rootid: "id"+ new Date().getTime()+"",
			searchKey: "",
			filtres: this.list,
			fuse : new Fuse(this.list, fuseOptions),
			checkeds: this.value || [],
 			composantOption			
		}
	},
	methods: {
		selectAll(select){
				const ThisVue = this;
				if(select==false){
					ThisVue.checkeds = [];
					return;
				}
				this.filtres.map(u => {
					if((ThisVue.searchKey!="" && u.inSearch) && !ThisVue.checkeds[u.k]  ) 	ThisVue.checkeds.push(u.k)
					if(ThisVue.searchKey==""  && !ThisVue.checkeds[u.k]  ) ThisVue.checkeds.push(u.k)
				})
		}
	},
	watch: {
		"searchKey"(val) {
			this.search = this.fuse.search(val);
			let indexSearch = this.search.map(e => {
				return e.item.k;
			});
			this.filtres.map(u => {
				u.inSearch = (indexSearch.indexOf(u.k) > -1);
			})
		},
	},
 

	template: `
	<div class="card border-0 m-0 p-2" style="min-height:100%; max-height: 50rem; min-width: 16rem;">
		<div v-if="(composantOption.search)" class="m-0 mt-1 p-1 px-2 ">
			<input type="search" class="form-control p-2 fs-5 sorm-control-rounded list-search"  v-model="searchKey"  placeholder="Search">
		</div>
		<div class="border-0 m-0 p-3 px-2">
			<small class="main mainLink link-primary me-2" @click="selectAll(true)"> Select </small>	
			<small class="main mainLink link-primary" @click="selectAll(false)"> Clear</small>

			<button @click="$emit('fin', name, checkeds )" class="btn btn-sm btn-dark d-md-inline-block float-end p-0 px-2"> ok </button>

		</div>
		<div class="card-body overflow-auto p-0 m-0 mx-1 border-0 ps-1" style="max-height:11rem ">
				<div class="col">
					<ul class="list-group list-group-flush list">
						<template v-for="filtre in filtres">
							<li class="list-group-item p-0 py-1 m-0 mx-1 border-0 fs-5"  :style="(filtre.inSearch===false && searchKey!='' )? 'display:none':''  ">
								<input class="form-check-input"  :name="filtre.k" v-model="checkeds" type="checkbox" :value="filtre.k" :id="rootid+filtre.k"   >
								<label class="form-check-label ps-2" :for="rootid+filtre.k">{{filtre.v.split('|').pop()||'none'}} </label>
							</li>
						</template>
					</ul>
				</div>					
		</div>
	
		<div class="card-footer border-0 text-end mt-2 p-0 py-1">				
		</div>
	</div>`
}

export { dropdownFilter };
